import {Component, Input, OnChanges, ViewChild} from '@angular/core';
import {Meeting} from '../../models/student/meeting.model';
import {StudentService} from '../../services/student.service';
import {ActivatedRoute} from '@angular/router';

import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {PrintOptions} from '../../common/components/buttons/print-options.helper';
import {DataType, Header, SortDirection} from '../../components/helpers/sortableTable/sortableTable.component';
import {DistrictService} from '../../services/district.service';
import {StudentMeetingComponent} from './student.meeting.component';
import {TypesService} from '../../services/types.service';
import {DistrictTypeDto} from '../../common/dtos/districtTypeDto';
import {DistrictMeetingProblemDto} from '../../common/dtos/districtMeetingProblemDto';
import {MeetingDto} from '@sidr/dto-types';


@Component({
  selector: `student-meetings`,
  styles: [
    `@media screen {
      .meeting-selected {
        display: none;
      }
    }`
  ],
  templateUrl: 'student.meetings.component.html'
})
export class StudentMeetingsComponent implements OnChanges {
  @Input() printOptions: PrintOptions;
  @Input() districtId: string;
  @Input() studentId: string;

  @ViewChild('openMeeting') openMeeting: StudentMeetingComponent;


  editing: boolean;
  topics: DistrictTypeDto[];
  problems: DistrictMeetingProblemDto[];
  nextsteps: DistrictTypeDto[];
  strcons: DistrictTypeDto[];

  selectedIndex: number;

  meetings: MeetingDto[];
  meeting: string;
  headers: Header[];

  constructor(
    private studentService: StudentService,
    private districtService: DistrictService,
    private typesService: TypesService,) {
    this.headers = [];
    this.selectedIndex = -1;
    this.headers.push(new Header('Meeting Date', 'date', false, DataType.Date, {
      sortOrder: SortDirection.Descending,
      dateFormat: 'shortDate'
    }));
    this.headers.push(new Header('Topic', 'topic', false, DataType.String));
    this.editing = false;
  }

  ngOnChanges(): void {
    this.getData();
  }

  closeMeeting() {
    if (this.openMeeting.dirty &&
      this.openMeeting.touched &&
      this.openMeeting.editing &&
      !confirm('Unsaved data, are you sure you want to close?')) {
      return;
    } else {
      this.getData();
    }
    this.selectedIndex = -1;
  }

  newMeeting() {
    const now = new Date(Date.now());
    let month = (now.getMonth() + 1).toString();
    if (month.length === 1) {
      month = '0' + month;
    }
    let day = now.getDate().toString();
    if (day.length === 1) {
      day = '0' + day;
    }

    this.meetings.push({
      id: '',
      notes: '',
      date: `${now.getFullYear()}-${month}-${day}`,
      topic: '',
      last_update: '',
      next_step_list: [],
      participant_ids: [],
      problems: [],
      strcons: [],
      next_steps: '',
      other_participants: ''
    });

    this.selectedIndex = this.meetings.length - 1;
    this.editing = true;
  }

  open(meeting: Meeting) {
    for (let i = 0; i < this.meetings.length; i++) {
      if (meeting.id === this.meetings[i].id) {
        this.selectedIndex = i;
        this.editing = false;
        break;
      }
    }
  }

  delete(meeting: Meeting) {
    this.studentService.deleteMeeting(this.districtId, this.studentId, <string>meeting.id).subscribe(() => {
      this.getData();
    });
  }

  getData() {
    if (!this.districtId && !this.studentId) {
      return;
    }
    this.studentService.getMeetings(this.districtId, this.studentId).subscribe(r => {
      this.meetings = r || [];
      this.meetings.sort((a: MeetingDto, b: MeetingDto) => {
        return a.date! > b.date! ? -1 : 1;
      });
    });
    this.typesService.getBasicType(this.districtId, TypesService.MeetingTopic).subscribe(r => {
      this.topics = r || [];
    });
    this.typesService.getBasicType(this.districtId, TypesService.MeetingNextStep).subscribe(r => {
      this.nextsteps = r || [];
    });
    this.districtService.getMeetingProblems(this.districtId).subscribe(r => {
      this.problems = r || [];
    });
    this.typesService.getBasicType(this.districtId, TypesService.MeetingStrCon).subscribe(r => {
      this.strcons = r || [];
    });
  }

  copyMeeting(m: MeetingDto) {
    this.meetings.push({
      notes: m.notes,
      date: m.date,
      topic: m.topic,
      last_update: m.last_update,
      next_step_list: m.next_step_list,
      participant_ids: m.participant_ids,
      problems: m.problems,
      strcons: m.strcons,
      next_steps: m.next_steps,
      other_participants: m.other_participants
    });

    this.selectedIndex = this.meetings.length - 1;
    this.editing = true;
  }
}
